import Image from 'next/image'
import React from 'react'
import styled from 'styled-components'

import Container from '../../components/Container'
import { MEDIA_QUERY_DESKTOP } from '../../utils/media-query'

const Component = styled.div`
  padding: 2rem 0;
  border-top: 1px solid rgba(255, 255, 255, .15);

  ${MEDIA_QUERY_DESKTOP} {
    padding: 4rem 0;
  }
`

const Header = styled.div``

const Description = styled.div`
  opacity: .5;
  max-width: 720px;
  margin-top: 2rem;

  ${MEDIA_QUERY_DESKTOP} {
    font-size: 18px;
  }
`

const SectionVideoWrapper = styled.div`
  margin-left: auto;
  position: relative;
  order: 2;

  ${MEDIA_QUERY_DESKTOP} {
    order: initial;

    &::after {
      position: absolute;
      z-index: 1;
      content: '';
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: linear-gradient(270deg, rgba(0, 0, 0, 0) 25%, #000000 90%);
    }
  }
`

const SectionText = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex-grow: 1;
  order: 1;
  margin-top: 1rem;

  ${MEDIA_QUERY_DESKTOP} {
    margin-top: 0;
    order: initial;
  }
`

const SectionTitle = styled.h2`
`

const SectionDescription = styled.div`
  opacity: .5;
  margin-bottom: 2rem;

  ${MEDIA_QUERY_DESKTOP} {
    margin-bottom: 0;
    font-size: 18px;
  }
`

const SectionVideo = styled.video`
  // object-fit: cover;
  object-position: right;
`

const Section = styled.div`
  display: flex;
  margin: 2rem 0;
  flex-direction: column;

  ${MEDIA_QUERY_DESKTOP} {
    flex-direction: row;
    margin: 4rem 0;

    &:nth-child(odd) {
      ${SectionVideoWrapper} {
        &::after {
          right: -2px; // Prevent glitches
          background: linear-gradient(90deg, rgba(0, 0, 0, 0) 25%, #000000 90%);
        }

        margin-right: 1rem;
      }

      ${SectionVideo} {
        object-position: left;
      }
    }
  }
`

const LOGO_SCALE = 0.35

const VoidInfo = () => {
  return (
    <Component>
      <Container>
        <Header>
          <Image
            src='/images/void-logo@2x.png'
            alt='Void'
            width={573 * LOGO_SCALE}
            height={137 * LOGO_SCALE}
          />
          <Description>
            VOID is our online visual synthesis and sequence software built using WebGL2.
            Visuals made with VOID consist of multiple layers of shaders and render in the browser, in real time.
          </Description>
        </Header>
        <Section>
          <SectionText>
            <SectionTitle>
              Synthesize
            </SectionTitle>
            <SectionDescription>
              Create complex visual Objects by customising and automating shaders.
            </SectionDescription>
          </SectionText>
          <SectionVideoWrapper>
            <SectionVideo
              src='/images/void-recording-synth.mp4'
              loop
              muted
              playsInline
              autoPlay
              width='100%'
              height='100%'
            />
          </SectionVideoWrapper>
        </Section>
        <Section>
          <SectionVideoWrapper>
            <SectionVideo
              src='/images/void-recording-seq-2.mp4'
              loop
              muted
              autoPlay
              playsInline
              width='100%'
              height='100%'
            />
          </SectionVideoWrapper>
          <SectionText>
            <SectionTitle>
              Sequence
            </SectionTitle>
            <SectionDescription>
              Combine and loop visuals by sequencing it on top of the audio waveform.
            </SectionDescription>
          </SectionText>
        </Section>
      </Container>
    </Component>
  )
}

export default VoidInfo
